import Vue from 'vue'

Vue.filter('formatAccessLevel', value => {

    return [
        null,
        'User',
        'Member',
        null,
        null,
        'O5',
        'Administrator'
    ][value]

})